let i18nInstance;
export const getI18nInstance = ()=>{
    return i18nInstance;
};
export const setI18nInstance = (i18n)=>{
    i18nInstance = i18n;
};
